import nodeService from "@/services/nodejs"
// import cakeService from "@/services/cakephp"
// import janooService from "@/services/janoo/index"

const createMessageOLD = (state, params) => {
    var message = {}
    state.commit("RESET_MESSAGE")

    if (params.typeMessage == "text") {
        message = {
            typeMessage: "text",
            messageBody: {
                number: params.messageBody.number,
                message: params.messageBody.message,
            },
        }
    }

    if (params.typeMessage == "image") {
        message = {
            typeMessage: "image",
            messageBody: {
                number: params.messageBody.number,
                path: params.messageBody.path,
                filename: params.messageBody.filename,
                caption: params.messageBody.caption,
            },
        }
    }
    state.commit("SET_MESSAGE", message)
}

const resetAllMessages = (state) => {
    state.commit("RESET_MESSAGE")
    state.commit("RESET_CUSTOMER_USER_CREATED")
    state.commit("RESET_CUSTOMER_ACTIVATED_AGENT")
    state.commit("RESET_VENDOR_USER_CREATED")
    state.commit("RESET_REQUEST_INSTITUTION")
}

/**
 *
 * @param {*} state
 * @param {Array} params [number,messageType,messageModel,[message data itens]]
 * @returns
 */
const createMessage = (state, params) => {
    resetAllMessages(state)

    let message = {}
    let messageModel = 'default message'
    let number = ''
    let typeMessage = 'text'
    let scheduled_msg_title = ''
    let scheduled_msg_send_datetime = new Date()
    let messageArrayData = []

    //Message number
    if (params[0]) {
        number = params[0]
    } else {
        console.error('Informe o número para envio da mensagem (ex: +55 75 99863-4343')
    }

    //message text model. use {x} to indicate position x in data array
    if (params[2]) {
        switch (params[2]) {
            case 'customer_user_created':
                scheduled_msg_title = state.state.customer_user_created.scheduled_msg_title
                messageModel = state.state.customer_user_created.messageModel
                break

            case 'customer_activated_agent':
                scheduled_msg_title = state.state.customer_activated_agent.scheduled_msg_title
                messageModel = state.state.customer_activated_agent.messageModel
                break

            case 'vendor_user_created':
                scheduled_msg_title = state.state.vendor_user_created.scheduled_msg_title
                messageModel = state.state.vendor_user_created.messageModel
                break

            case 'request_institution':
                scheduled_msg_title = state.state.request_institution.scheduled_msg_title
                messageModel = state.state.request_institution.messageModel
                break

            default:
                break
        }
    }

    //message data array
    if (params[3] && Object.prototype.toString.call(params[3]) == '[object Array]') {
        messageArrayData = params[3]
        messageArrayData.forEach((data, index) => {
            messageModel = messageModel.replaceAll('\{' + index + '\}', data)
        })
    }

    //message type
    if (params[1]) {
        typeMessage = params[1]

        message = JSON.parse(JSON.stringify(state.state.message.message))
        message.typeMessage = typeMessage
        message.messageBody.number = number

        switch (typeMessage) {
            case 'text':
                message.messageBody.message = messageModel
                break
            case 'image':
                message.messageBody.caption = messageModel
                message.messageBody.path = ''
                message.messageBody.filename = ''
                break
            default:
                break
        }
    } else {
        console.error('Informe o tipo da mensagem (text, image)')
    }
    if(number.length > 15){
        message.messageBody.group = true
    }

    let place_name = 'Janoo'
    let place_id = 1
    try {
        place_name = state.rootGetters["auth/getPlace"].name
        place_id = state.rootGetters["auth/getPlace"].id
    } catch (error) { }

    let messageReady = {
        "title": scheduled_msg_title,
        "message": message,
        "sendDate": scheduled_msg_send_datetime.toISOString(),
        "errorCount": 0,
        "from": place_name,
        "to": number,
        "ref": null,
        "refId": null,
        "placeId": place_id
    }

    state.commit("SET_MESSAGE", messageReady)
    return messageReady
}

const sendMessage = (state) => {
    const message = state.state.message.message
    if(message.messageBody.number){
        nodeService.postWhatsappMessage(message)
    }
    return
}

const scheduleMessage = (state,message) => {
    if(message.message.messageBody.number){
        nodeService.scheduleWhatsappMessage(message)
    }
    return
}


export default {
    createMessage,
    scheduleMessage,
    sendMessage
}
